import {SiteService} from "./site.service";
import {Component} from "@angular/core";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {UploaderDialogResult} from "../uploader-wrapper/uploader-dialog.model";
import {ConfirmDialogService} from "../confirm-dialog/confirm-dialog-service";
import {contactTypes} from "../types/contact";
import {handleErrors} from "../misc/handle-errors.decorator";
import {SiteDetailModel, siteDetailModelFactory} from "./site-detail.model";
import {ModifyContactDialogComponent} from "../contact/modify-contact-dialog.component";
import {ContactService} from "../contact/contact.service";
import {DialogService} from "../bootstrap-modal/dialog.service";

@Component({
  selector: "project",
  templateUrl: "./site-show.template.pug",
  providers: [
    SiteService,
    ConfirmDialogService,
    ContactService,
  ],
})

export class SiteComponent extends RouteHelper {
  error: Error;
  id: string;
  site: SiteDetailModel = siteDetailModelFactory();
  contactTypes: any[] = contactTypes;
  hasContacts: boolean = false;

  paramsMap: RouteMapping[] = [
    {fieldName: "id", paramName: "id"} as RouteMapping,
  ];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private siteService: SiteService,
    public confirmDialogService: ConfirmDialogService,
    private dialogService: DialogService,
    private contactService: ContactService,
  ) {
    super();
  }

  @handleErrors()
  async loadData() {
    this.site = await this.siteService.getSiteById(this.id);
    this.hasContacts = this.contactTypes.some(type => this.site[type.field]);
  }

  navigate(queryParams: Params, skipLocationChange: boolean = false): Promise<boolean> {
    return this.router.navigate(["site"], {queryParams, skipLocationChange});
  }

  importContactsClosed(event: any): void {
    const result = event["value"] as UploaderDialogResult;
    if (result.responses.length) {
      this.loadData();
    }
  }

  @handleErrors()
  async editSiteContact(type: string) {
    const trimmedType = type.replace("Contact", "");

    const result = await ModifyContactDialogComponent.showContactModal(
      this.dialogService,
      {
        targetType: trimmedType,
        targetLevel: "site",
        targetId: this.site.id,
        contactService: this.contactService,
      },
    );

    if (!result.changed) return;
    this.site[type] = result.contact;
  }

  remove(): void {
    let warning = "";
    if (this.site.plannedDevices || this.site.orderCount || this.site.deploymentCount) {
      warning = ` ${this.site.plannedDevices} asset(s), ${this.site.orderCount} order(s) 
      and ${this.site.deploymentCount} deployment(s) will be deleted.`;
    }

    this.confirmDialogService.showConfirm("Confirm", `Are you sure you want to delete this site?${warning}`)
      .subscribe((result: boolean) => {
        if (result) {
          this.error = undefined;
          this.siteService.remove(this.site.id)
            .then(
              () => {
                this.router.navigate(["/sites"], {queryParams: {projectId: this.site.projectId}});
              },
              (error) => {
                this.error = error;
                window.scrollTo(0, 0);
              },
            );
        }
      });
  }
}
